import { Injectable } from '@angular/core';
import { Toast } from './toast.models';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Injectable({ providedIn: 'root' })
export class ToastService {
	toasts: Toast[] = [];

	constructor(private sanitizer: DomSanitizer) { }

	show(toast: Toast): Toast {
		// Si le message est une string, on le prépare en HTML
		let safeMessage: SafeHtml = toast.message as SafeHtml;

		if (typeof toast.message === 'string') {
			const formatted = toast.message.replace(/\\n/g, '<br>');  // Remplacer \\n par <br>
			safeMessage = this.sanitizer.bypassSecurityTrustHtml(formatted);
		}

		const stored: Toast = {
			...toast,
			message: safeMessage,
		};
		this.toasts.push(stored);
		return stored;
	}

	remove(toast: Toast) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}
}
